import { ItemDef, ItemFamily } from '../types';

/**
 * Placeholder item set matching ASSET.md section 3.
 * `key` matches the texture key generated in PreloadScene until real
 * art (item_*.png) replaces the procedural textures.
 */
export const ITEM_DEFS: ItemDef[] = [
  { key: 'item_pumpkin', family: ItemFamily.Halloween, points: 10 },
  { key: 'item_candy_corn', family: ItemFamily.Halloween, points: 10 },
  { key: 'item_bat', family: ItemFamily.Halloween, points: 10 },
  { key: 'item_ghost', family: ItemFamily.Halloween, points: 10 },
  { key: 'item_ornament', family: ItemFamily.Christmas, points: 10 },
  { key: 'item_present', family: ItemFamily.Christmas, points: 10 },
  { key: 'item_candy_cane', family: ItemFamily.Christmas, points: 10 },
  { key: 'item_snowflake', family: ItemFamily.Christmas, points: 10 },
  { key: 'item_fusion_pumpkin_hat', family: ItemFamily.Fusion, points: 25 },
  { key: 'item_fusion_bat_ornament', family: ItemFamily.Fusion, points: 25 }
];

const STARTER_KEYS = new Set(['item_pumpkin', 'item_ghost', 'item_ornament', 'item_present']);
const CORE_ITEMS = ITEM_DEFS.filter((item) => item.family !== ItemFamily.Fusion);
const STARTER_ITEMS = CORE_ITEMS.filter((item) => STARTER_KEYS.has(item.key));

export function pickRandomItem(pool: 'starter' | 'core' | 'full'): ItemDef {
  const candidates = pool === 'starter' ? STARTER_ITEMS : pool === 'core' ? CORE_ITEMS : ITEM_DEFS;
  return candidates[Phaser.Math.Between(0, candidates.length - 1)];
}
